"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
//= ENUM 
// export enum Link {
//     LoginAdmin ='http://localhost:3306/api/auth/login-admin',
//     Management = 'http://localhost:3306/api/admin/management',
//     Telegram = 'http://localhost:3306/api/management/telegram',
//     RefreshToken = 'http://localhost:3306/api/auth/refresh-token-check'
// }
var Link;
(function (Link) {
    Link["LoginAdmin"] = "https://server.best-potolok.by/api/auth/login-admin";
    Link["Management"] = "https://server.best-potolok.by/api/admin/management";
    Link["Telegram"] = "https://server.best-potolok.by/api/management/telegram";
    Link["RefreshToken"] = "http://server.best-potolok.by/api/auth/refresh-token-check";
})(Link || (exports.Link = Link = {}));
